import {asyncRouterMap, constantRouterMap} from '../../router/index.js';

function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.indexOf(role) >= 0)
  } else {
    return true
  }
}


function deepclone(obj) { // 深拷贝
  let data;
  if (Object.prototype.toString.call(obj) === '[object Array]') {
    data = [];
    for (let index = 0; index < obj.length; index++) {
      data.push(deepclone(obj[index]));
    }
  } else if (Object.prototype.toString.call(obj) === '[object Object]') {
    data = {};
    for (let key in obj) {
      data[key] = deepclone(obj[key]);
    }
  } else {
    return obj;
  }
  return data;
}

function getAccessedRouters(roles, routers) {
  return routers.filter((v) => {
    if (roles.indexOf('admin') >= 0) {
      return true;
    } else if (hasPermission(roles, v)) {
      if (v.children && v.children.length > 0) {
        v.children = getAccessedRouters(roles, v.children);
      }
      return true;
    }
  });
}

const permission = {
  state: {
    routers: constantRouterMap, // 当前所有路由
    addRouters: [], // 动态添加的路由数据
    mainChildrenRouters: [], // /main 路由下所有子路由列表，用于动态渲染左边栏按钮
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
    SET_CHILDREN_ROUTERS: (state, routers) => {
      state.mainChildrenRouters = routers;
    }
  },
  actions: {
    GenerateRoutes({commit}, data) { // 根据用户roles动态添加路由
      return new Promise(resolve => {
        const {roles} = data; // 用户的权限数组
        // 先将所有可添加的路由保存起来
        var allRouter = deepclone(asyncRouterMap);
        // 存放/main路由下面所有children路由  （注：暂时默认为路由数组allRouter中第一个allRouter[0]）
        var childrenRouter = deepclone(asyncRouterMap);

        // 筛选出用户有权限访问的路由 （注：admin可以访问所有路由）
        // const accessedRouters = getAccessedRouters(roles, childrenRouter);
        const accessedRouters = childrenRouter.filter(v => {
          if (! v.isMenu) return true; // 非菜单栏不参与筛除
          if (roles.indexOf('admin') >= 0) return true;
          if (hasPermission(roles, v)) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter(child => {
                if (hasPermission(roles, child)) {
                  return child
                }
                return false;
              });
              return v
            } else {
              return v
            }
          }
          return false;
        });
        var realRouter = [];
        accessedRouters.forEach(r => {
          if (! r.isMenu) {
            realRouter.push(r);
          } else if (typeof r.children === 'object' && r.children.length > 0) {
            // 根据筛选出来的子路由重新设置添加的动态路由数据
            r.redirect = r.children[0].path;
            realRouter.push(r);
          }
        });

        // 存放子路由列表
        commit('SET_CHILDREN_ROUTERS', realRouter);
        // 存放添加的动态路由
        commit('SET_ROUTERS', realRouter);
        resolve();
      })
    }
  }
};

export default permission;



// WEBPACK FOOTER //
// ./src/vuex/modules/permission.js